import { z } from "zod";

export const errorResponse = z.object({
  message: z.string(),
  errors: z.record(z.array(z.string())),
});
export type ValidationErrors = z.infer<typeof errorResponse>;
